// extracted by mini-css-extract-plugin
module.exports = {"container":"step-five_container__mrlZy","title":"step-five_title__3wKul","text":"step-five_text__2tN38"};